import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-error-02',
	templateUrl: './icon-error-02.component.svg',
})
export class IconError02Component {}
